export default __webpack_public_path__ + "static/MediaShuttle-Hero-Fixed-f4e7527410681b32e1a402df41f840fc.png";